import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pf0004',
    ecrans: ['00-2']
});
